/* eslint-disable jsx-a11y/anchor-is-valid */
import {Modal, Table} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {useAuth} from '../../auth'
import {getAllInvestorUpdatesAPI} from '../core/_request'
import {InvestorUpdatesModel} from '../core/_models'
import {useEffect, useState} from 'react'
import {useDateFormat} from '../../../hooks/useDateFormat'
import {DateTime} from 'luxon'
// import {DisplayImage} from '../../widgets/components/General/DisplayImage'
import {toast} from 'react-toastify'
import {Link} from 'react-router-dom'
import {OverlayTrigger} from 'react-bootstrap'
import { Tooltip } from 'react-bootstrap'
import {GET_FILE_URL} from '../../onboarding/core/_requests'


const AddInvestorUpdateModal = ({
  addInvestorUpdateModalShow,
  setAddInvestorUpdateModalShow,
  formik,
}: any) => {
  const {formatMessage} = useIntl()
  const {companyId} = useAuth()
  const [localUpdateId, setLocalUpdateId] = useState<string>()
  const [investorUpdatesData, setInvestorUpdatesData] = useState<
    InvestorUpdatesModel[] | undefined
  >()
  const {getDateValue} = useDateFormat()

  const onSubmit = () => {}

  const handleClose = () => {
    setAddInvestorUpdateModalShow(false)
  }

  const getAllInvestorUpdate = async () => {
    try {
      if (companyId) {
        const {
          data: {
            data: {investorUpdates},
            success,
          },
        }: any = await getAllInvestorUpdatesAPI(
          +companyId!,
          null,
          null,
          undefined,
          undefined,
          'PUBLISHED'
        )

        if (success) {
          setInvestorUpdatesData([...investorUpdates])
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getAllInvestorUpdate()
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleInsert = () => {
    if (localUpdateId) {
      formik.values['updateId'] = localUpdateId?.toString()
      toast.success(formatMessage({id: 'Investor Update Successfully Inserted'}))
    }

    handleClose()
  }
  return (
    <>
      <Modal
        size='lg'
        show={addInvestorUpdateModalShow}
        onHide={() => {
          setAddInvestorUpdateModalShow(false)
        }}
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <form onSubmit={onSubmit}>
          <Modal.Header closeButton>
            <h2>{formatMessage({id: 'Select Existing Updates'})}</h2>
          </Modal.Header>
          <Modal.Body className='mx-5'>
            <div className='d-flex justify-content-between'>
              <i className='fa fa-file-alt text-primary pe-2 fs-3 mb-0'></i>
              <div>
                <p className='mb-0'>{formatMessage({id: 'What is Existing update?'})}</p>
                <small className=''>
                  {formatMessage({
                    id: 'Below updates are available for you to insert it in your email body. Selected update’s link will be added to the email body as a button and will be accessible to the receiver.',
                  })}
                </small>
              </div>
            </div>
            <div className='scroll-modal'>
              <Table>
                <thead>
                  <tr>
                    <th className='text-muted ps-8'>{formatMessage({id: 'Title'})}</th>
                    <th className='text-muted'> {formatMessage({id: 'Created on'})}</th>
                    <th className='text-muted'> {formatMessage({id: 'Publish by'})}</th>
                    <th className='text-muted'>{formatMessage({id: 'Last Updated'})}</th>
                    <th className='text-muted'> {formatMessage({id: 'Actions'})}</th>
                  </tr>
                </thead>
                <tbody>
                  {investorUpdatesData?.map((investorUpdate: any) => (
                    <tr key={investorUpdate?.updateId}>
                      <td>
                        <div className='form-check pb-3'>
                          <input
                            className='form-check-input'
                            type='radio'
                            id='investorUpdate'
                            value={investorUpdate?.updateId}
                            name='updateId'
                            defaultChecked={investorUpdate?.updateId === +formik.values.updateId}
                            onChange={(e) => {
                              setLocalUpdateId(e.target.value)
                            }}
                          />
                          <label className='form-check-label' htmlFor='investorUpdate'>
                            {investorUpdate?.title}
                          </label>
                        </div>
                      </td>
                      <td>
                        {investorUpdate.createdAt
                          ? getDateValue(
                              new Date(investorUpdate.createdAt).toISOString()?.toString()
                            )
                            ? getDateValue(
                                new Date(investorUpdate.createdAt).toISOString()?.toString()
                              )
                            : DateTime.fromISO(
                                new Date(investorUpdate.createdAt).toISOString()?.toString()
                              ).toLocaleString(DateTime.DATE_MED)
                          : '-'}
                      </td>
                      <td>
                        {/* <DisplayImage
                          imgName={investorUpdate?.user?.file?.name}
                          width='24px'
                          height='24px'
                          alt='profile'
                          fit='contain'
                        /> */}
                        <OverlayTrigger
                          placement='bottom'
                          overlay={
                            <Tooltip id='tooltip'>
                              <p className='m-0'>
                                {investorUpdate?.user?.firstName} {investorUpdate?.user?.lastName}
                              </p>
                            </Tooltip>
                          }
                        >
                          <img
                            src={`${GET_FILE_URL}/${investorUpdate?.user?.file?.name}`}
                            height='20'
                            width='20'
                            alt='user'
                            style={{objectFit: 'contain'}}
                            className='ms-5'
                          />
                        </OverlayTrigger>
                      </td>

                      <td>
                        {investorUpdate?.updatedAt
                          ? getDateValue(
                              new Date(investorUpdate.createdAt).toISOString()?.toString()
                            )
                            ? getDateValue(
                                new Date(investorUpdate.createdAt).toISOString()?.toString()
                              )
                            : DateTime.fromISO(
                                new Date(investorUpdate.createdAt).toISOString()?.toString()
                              ).toLocaleString(DateTime.DATE_MED)
                          : '-'}
                      </td>
                      <td>
                        <Link to={`/updates/preview/${investorUpdate?.updateId}`} target='_blank'>
                          <button type='button' className='btn-sm btn btn-bg-light'>
                            {formatMessage({id: 'Preview'})}
                          </button>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type='button'
              className='btn btn-bg-secondary font-weight-400 font-size-13'
              onClick={handleClose}
            >
              {formatMessage({id: 'Cancel'})}
            </button>

            <button type='button' className='btn btn-primary' onClick={handleInsert}>
              {formatMessage({id: 'Insert'})}
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  )
}

export {AddInvestorUpdateModal}
